var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardDownloadIconNormal = function SvgNewcsDashboardDownloadIconNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_download_icon_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58 207h16v14H58z",
    "data-name": "\\u77E9\\u5F62 498"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_download_icon_normal_svg__a)",
    transform: "translate(-58 -207)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M58.75 220.984a.75.75 0 0 1-.751-.75v-5.659a.75.75 0 0 1 .751-.751.75.75 0 0 1 .75.751v4.91h12.994v-4.91a.75.75 0 0 1 .75-.751.75.75 0 0 1 .75.751v5.659a.75.75 0 0 1-.75.75Zm6.9-4.338-3.793-3.793a.5.5 0 0 1 .354-.853h3.043v-4.251A.75.75 0 0 1 66 207a.75.75 0 0 1 .75.75V212h3.043a.5.5 0 0 1 .354.853l-3.793 3.793a.5.5 0 0 1-.354.146.5.5 0 0 1-.354-.146Z",
    "data-name": "\\u8054\\u5408 82"
  }))));
};
export default SvgNewcsDashboardDownloadIconNormal;